import React from 'react'
import { Shell } from '~/components/molecules/Shell'
import * as S from './styles'
import { DbaHeader, DbaMap } from '~/components/molecules/Maps/DbaMap'

export const Screen = () => {
  return (
    <Shell>
      <S.ScreenWrapper>
        <DbaHeader />
        <DbaMap />
      </S.ScreenWrapper>
    </Shell>
  )
}
